"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryDelete = exports.handleCacheFailure = exports.cacheDebug = exports.saveCache = exports.restoreCache = exports.hashStrings = exports.hashFileNames = exports.getCacheKeyPrefix = exports.generateCacheKey = exports.CacheKey = exports.isCacheCleanupEnabled = exports.isCacheDebuggingEnabled = exports.isCacheOverwriteExisting = exports.isCacheWriteOnly = exports.isCacheReadOnly = exports.isCacheDisabled = void 0;
const core = __importStar(require("@actions/core"));
const cache = __importStar(require("@actions/cache"));
const github = __importStar(require("@actions/github"));
const exec = __importStar(require("@actions/exec"));
const crypto = __importStar(require("crypto"));
const path = __importStar(require("path"));
const fs = __importStar(require("fs"));
const params = __importStar(require("./input-params"));
const CACHE_PROTOCOL_VERSION = 'v9-';
const CACHE_KEY_PREFIX_VAR = 'GRADLE_BUILD_ACTION_CACHE_KEY_PREFIX';
const CACHE_KEY_OS_VAR = 'GRADLE_BUILD_ACTION_CACHE_KEY_ENVIRONMENT';
const CACHE_KEY_JOB_VAR = 'GRADLE_BUILD_ACTION_CACHE_KEY_JOB';
const CACHE_KEY_JOB_INSTANCE_VAR = 'GRADLE_BUILD_ACTION_CACHE_KEY_JOB_INSTANCE';
const CACHE_KEY_JOB_EXECUTION_VAR = 'GRADLE_BUILD_ACTION_CACHE_KEY_JOB_EXECUTION';
const SEGMENT_DOWNLOAD_TIMEOUT_VAR = 'SEGMENT_DOWNLOAD_TIMEOUT_MINS';
const SEGMENT_DOWNLOAD_TIMEOUT_DEFAULT = 10 * 60 * 1000;
function isCacheDisabled() {
    if (!cache.isFeatureAvailable()) {
        return true;
    }
    return params.isCacheDisabled();
}
exports.isCacheDisabled = isCacheDisabled;
function isCacheReadOnly() {
    return !isCacheWriteOnly() && params.isCacheReadOnly();
}
exports.isCacheReadOnly = isCacheReadOnly;
function isCacheWriteOnly() {
    return params.isCacheWriteOnly();
}
exports.isCacheWriteOnly = isCacheWriteOnly;
function isCacheOverwriteExisting() {
    return params.isCacheOverwriteExisting();
}
exports.isCacheOverwriteExisting = isCacheOverwriteExisting;
function isCacheDebuggingEnabled() {
    return params.isCacheDebuggingEnabled();
}
exports.isCacheDebuggingEnabled = isCacheDebuggingEnabled;
function isCacheCleanupEnabled() {
    return params.isCacheCleanupEnabled();
}
exports.isCacheCleanupEnabled = isCacheCleanupEnabled;
class CacheKey {
    constructor(key, restoreKeys) {
        this.key = key;
        this.restoreKeys = restoreKeys;
    }
}
exports.CacheKey = CacheKey;
function generateCacheKey(cacheName) {
    const cacheKeyBase = `${getCacheKeyPrefix()}${CACHE_PROTOCOL_VERSION}${cacheName}`;
    const cacheKeyForEnvironment = `${cacheKeyBase}|${getCacheKeyEnvironment()}`;
    const cacheKeyForJob = `${cacheKeyForEnvironment}|${getCacheKeyJob()}`;
    const cacheKeyForJobContext = `${cacheKeyForJob}[${getCacheKeyJobInstance()}]`;
    const cacheKey = `${cacheKeyForJobContext}-${getCacheKeyJobExecution()}`;
    if (params.isCacheStrictMatch()) {
        return new CacheKey(cacheKey, [cacheKeyForJobContext]);
    }
    return new CacheKey(cacheKey, [cacheKeyForJobContext, cacheKeyForJob, cacheKeyForEnvironment]);
}
exports.generateCacheKey = generateCacheKey;
function getCacheKeyPrefix() {
    return process.env[CACHE_KEY_PREFIX_VAR] || '';
}
exports.getCacheKeyPrefix = getCacheKeyPrefix;
function getCacheKeyEnvironment() {
    const runnerOs = process.env['RUNNER_OS'] || '';
    return process.env[CACHE_KEY_OS_VAR] || runnerOs;
}
function getCacheKeyJob() {
    return process.env[CACHE_KEY_JOB_VAR] || github.context.job;
}
function getCacheKeyJobInstance() {
    const override = process.env[CACHE_KEY_JOB_INSTANCE_VAR];
    if (override) {
        return override;
    }
    const workflowName = github.context.workflow;
    const workflowJobContext = params.getJobMatrix();
    return hashStrings([workflowName, workflowJobContext]);
}
function getCacheKeyJobExecution() {
    return process.env[CACHE_KEY_JOB_EXECUTION_VAR] || github.context.sha;
}
function hashFileNames(fileNames) {
    return hashStrings(fileNames.map(x => x.replace(new RegExp(`\\${path.sep}`, 'g'), '/')));
}
exports.hashFileNames = hashFileNames;
function hashStrings(values) {
    const hash = crypto.createHash('md5');
    for (const value of values) {
        hash.update(value);
    }
    return hash.digest('hex');
}
exports.hashStrings = hashStrings;
function restoreCache(cachePath, cacheKey, cacheRestoreKeys, listener) {
    return __awaiter(this, void 0, void 0, function* () {
        listener.markRequested(cacheKey, cacheRestoreKeys);
        try {
            const cacheRestoreOptions = process.env[SEGMENT_DOWNLOAD_TIMEOUT_VAR]
                ? {}
                : { segmentTimeoutInMs: SEGMENT_DOWNLOAD_TIMEOUT_DEFAULT };
            const restoredEntry = yield cache.restoreCache(cachePath, cacheKey, cacheRestoreKeys, cacheRestoreOptions);
            if (restoredEntry !== undefined) {
                listener.markRestored(restoredEntry.key, restoredEntry.size);
            }
            return restoredEntry;
        }
        catch (error) {
            listener.markNotRestored(error.message);
            handleCacheFailure(error, `Failed to restore ${cacheKey}`);
            return undefined;
        }
    });
}
exports.restoreCache = restoreCache;
function saveCache(cachePath, cacheKey, listener) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const savedEntry = yield cache.saveCache(cachePath, cacheKey);
            listener.markSaved(savedEntry.key, savedEntry.size);
        }
        catch (error) {
            if (error instanceof cache.ReserveCacheError) {
                listener.markAlreadyExists(cacheKey);
            }
            else {
                listener.markNotSaved(error.message);
            }
            handleCacheFailure(error, `Failed to save cache entry with path '${cachePath}' and key: ${cacheKey}`);
        }
    });
}
exports.saveCache = saveCache;
function cacheDebug(message) {
    if (isCacheDebuggingEnabled()) {
        core.info(message);
    }
    else {
        core.debug(message);
    }
}
exports.cacheDebug = cacheDebug;
function handleCacheFailure(error, message) {
    if (error instanceof cache.ValidationError) {
        throw error;
    }
    if (error instanceof cache.ReserveCacheError) {
        core.info(`${message}: ${error}`);
    }
    else {
        core.warning(`${message}: ${error}`);
        if (error instanceof Error && error.stack) {
            cacheDebug(error.stack);
        }
    }
}
exports.handleCacheFailure = handleCacheFailure;
function tryDelete(file) {
    return __awaiter(this, void 0, void 0, function* () {
        const maxAttempts = 5;
        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
            if (!fs.existsSync(file)) {
                return;
            }
            try {
                const stat = fs.lstatSync(file);
                if (stat.isDirectory()) {
                    fs.rmSync(file, { recursive: true });
                }
                else {
                    fs.unlinkSync(file);
                }
                return;
            }
            catch (error) {
                if (attempt === maxAttempts) {
                    core.warning(`Failed to delete ${file}, which will impact caching. 
It is likely locked by another process. Output of 'jps -ml':
${yield getJavaProcesses()}`);
                    throw error;
                }
                else {
                    cacheDebug(`Attempt to delete ${file} failed. Will try again.`);
                    yield delay(1000);
                }
            }
        }
    });
}
exports.tryDelete = tryDelete;
function delay(ms) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise(resolve => setTimeout(resolve, ms));
    });
}
function getJavaProcesses() {
    return __awaiter(this, void 0, void 0, function* () {
        const jpsOutput = yield exec.getExecOutput('jps', ['-lm']);
        return jpsOutput.stdout;
    });
}
